<template>
	<b-modal :visible="visible" @change="change" @shown="show" @ok="ok">
		<template v-slot:modal-title><h4>Enter Yellow Bucket Container Data</h4></template>
		<ValidationObserver ref="observer">
			<form @submit.prevent="" class="ml-3">
				<!--			<FeedbackPanel></FeedbackPanel>-->
				<div class="row mb-1">
					<ValidationProvider v-slot="v" ref="containerName">
						<label for="containerName" class="font-weight-bold">Container Name</label>
						<b-form-input id="containerName" class="job-field form-control"
									  v-model="containerName"></b-form-input>
					</ValidationProvider>
				</div>
				<div class="row mb-1">
					<ValidationProvider v-slot="v" ref="pallet">
						<label for="pallet" class="font-weight-bold">Pallet</label>
						<b-form-input id="pallet" class="job-field form-control" v-model="pallet"></b-form-input>
					</ValidationProvider>
				</div>
				<div class="row mb-1">
					<ValidationProvider v-slot="v" ref="containerType">
						<label for="containerType" style="width: 193px;" class="font-weight-bold">Type</label>
						<v-select id="containerType" v-model="containerType"
									   :options="containerTypes"></v-select>
					</ValidationProvider>
				</div>
				<div class="row mb-1">
					<ValidationProvider v-slot="v" ref="packageWeight">
						<label for="packageWeight" class="font-weight-bold">Pkg Wt</label>
						<b-form-input id="packageWeight" class="job-field form-control"
									  v-model="packageWeight"></b-form-input>
					</ValidationProvider>
				</div>
				<div class="row mb-1">
					<ValidationProvider v-slot="v" ref="netWeight">
						<label for="netWeight" class="font-weight-bold">Net Wt</label>
						<b-form-input id="netWeight" class="job-field form-control" v-model="netWeight"></b-form-input>
					</ValidationProvider>
				</div>
				<div class="row mb-1">
					<label class="font-weight-bold w-100">Gross Wt</label>
					<div class="pl-3">{{ grossWeight }}</div>
				</div>
				<div class="row mb-1">
					<ValidationProvider v-slot="v" ref="grossUoM">
						<label for="grossUoM" class="font-weight-bold">Gross UoM</label>
						<v-select id="grossUoM" v-model="grossUoM"
									   :options="UoMs"></v-select>
					</ValidationProvider>
				</div>
			</form>
		</ValidationObserver>
<!--		<div class="card">
			<div class="card-header pt-2 pb-2" style="min-height: 48px">
				<span>Container Info</span>
			</div>
			<div class="card-body">
				<FeedbackPanel></FeedbackPanel>
				<div class="row ml-1">
					<ValidationProvider v-slot="v" ref="containerName">
						<label for="containerName" class="font-weight-bold">Container Name</label>
						<b-form-input id="containerName" class="job-field form-control" v-model="containerName"></b-form-input>
					</ValidationProvider>
				</div>
			</div>
		</div>-->
	</b-modal>
</template>

<script>
import feedbackMixin from "@/mixins/feedback";
import {ValidationProvider, ValidationObserver} from "vee-validate";
import { required } from 'vee-validate/dist/rules.umd';
import FeedbackPanel from "@/components/FeedbackPanel";
import {EventBus} from "@/event-bus";

export default {
	name: "YBContainerEditModal",
	mixins: [feedbackMixin],
	components: {
		ValidationProvider,
		ValidationObserver,
		FeedbackPanel
	},
	model: {
		prop: "visible",
		event: "change"
	},
	props: {
		visible: {
			type: Boolean
		},
		initialContainerName: {
			type: String
		},
		initialContainerType: {
			type: String
		},
		initialPallet: {
			type: String
		},
		initialGrossUoM: {
			type: String
		},
		initialPackageWeight: {
			type: Number,
			default: null
		},
		initialNetWeight: {
			type: Number,
			default: null
		},
		jobId: {
			type: String
		},
		id: {
			type: String
		},
		isNewLineItem: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		show() {

		},
		cancel() {
			let that = this
			this.validationRefs.forEach(value => {
				let validationProvider = this.$refs[value]
				if (validationProvider && validationProvider.flags.dirty) {
					that[value] = validationProvider.initialValue
					validationProvider.reset()
				}
			})
		},
		ok() {
			if (this.$refs.observer.flags.dirty/* && !this.$refs.observer.flags.invalid*/) {
				if (this.isNewLineItem) {
					this.createContainer()
				} else {
					this.editContainer()
				}
			} else {
				console.warn('Form is not valid')
			}
		},
		change(visible) {
			this.$emit("change", visible);
			this.cancel()
		},
		getContainerTypes() {
			return this.getValueList("Container Type", "container")
		},
		getUoMs() {
			return this.getValueList("UoM Container", "container")
		},
		createContainer() {
			let payload = {}
			let that = this
			this.validationRefs.forEach(value => {
				let validationProvider = this.$refs[value]
				if (validationProvider && validationProvider.flags.dirty) {
					payload[value] = that[value]
				}
			})
			payload["jobId"] = this.jobId
			this.axios.post('/3ds/api/yb-container/new', payload)
				.then(value => {
					console.log(JSON.stringify(value))
					this.$emit('container-created', {
						recordId: value.data.recordId
					})
				})
				.catch(reason => {
					console.error(JSON.stringify(reason))
					this.cancel()
				})
		},
		editContainer() {
			let payload = {}
			let that = this
			this.validationRefs.forEach(value => {
				let validationProvider = this.$refs[value]
				if (validationProvider && validationProvider.flags.dirty) {
					payload[value] = that[value]
				}
			})
			payload["id"] = this.id
			this.axios.patch(`/3ds/api/yb-container/edit/${this.id}`, payload)
				.then(value => {
					console.log(JSON.stringify(value))
					EventBus.$emit('container-edited', {
						recordId: value.data.recordId
					})
				})
				.catch(reason => {
					console.error(JSON.stringify(reason))
					this.cancel()
				})
		}
	},
	data() {
		return {
			containerName: this.initialContainerName,
			pallet: this.initialPallet,
			containerType: this.initialContainerType,
			packageWeight: this.initialPackageWeight,
			netWeight: this.initialNetWeight,
			grossUoM: this.initialGrossUoM,
			containerTypes: [],
			UoMs: ['', 'kg', 'lbs'],
			validationRefs: [
				"containerName",
				"containerType",
				"pallet",
				"grossUoM",
				"netWeight",
				"packageWeight"
			]
		}
	},
	computed: {
		grossWeight() {
			return (this.netWeight ? parseFloat(this.netWeight) : 0) + (this.packageWeight ? parseFloat(this.packageWeight) : 0)
		}
	},
	created() {
		let that = this
		this.getContainerTypes()
			.then(function (results) {
				that.containerTypes = results.data.valueList
				that.containerTypes.unshift("")
			});
	}
}
</script>

<style scoped>
::v-deep .vs--single.vs--open .vs__selected {
    position: initial;
}
</style>